// thunk.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import { clearCart } from './reducer';

// Thunk to clear the cart from local storage
export const clearCartStorage = createAsyncThunk(
  'cart/clearCart',
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(clearCart());
    } catch (error) {
      return thunkAPI.rejectWithValue('Failed to clear cart');
    }
  }
);
